export function convertAngleToDirection(angle) {
    let degrees = (angle * THREE.MathUtils.RAD2DEG + 180 + 45) % 360;

    if (degrees > 0 && degrees < 90) {
        return "north";
    } else if (degrees >= 90 && degrees < 180) {
        return "west";
    } else if (degrees >= 180 && degrees < 270) {
        return "south";
    } else {
        return "east";
    }
}
